import { useEffect, useState } from 'react'
import probeHasResponses from '../helpers/questionnaires/probeHasResponses'
import describeQueryError from '../helpers/firestore/describeQueryError'

// Zijn er al antwoorden, op een meetmoment, in een onderzoek of op één vraag?
//
// Bewust alleen een JA/NEE en geen telling: het aantal ingevulde vragenlijsten
// zou betekenen dat je élk antwoorddocument ophaalt (respondenten × vragen, al
// gauw duizenden). Een paar documenten opvragen is genoeg om te weten dát er
// antwoorden zijn. De query zelf staat in probeHasResponses.
//
// Nodig omdat useMomentHasResponses alleen op MomentID vroeg en het TOC-detail
// dezelfde vraag per indicator (FieldID) stelt; die hook is nu een dunne laag
// hierover.
//
// AI-CONTEXT: See docs/patterns.md#hook-firestore-custom

/**
 * @param {'MomentID'|'ResearchID'|'FieldID'} field - Waarop de antwoorden gezocht worden
 * @param {string} value - Het ID. Leeg = niet opvragen.
 * @returns {boolean|null} True/false zodra bekend, null zolang het antwoord
 *   nog niet binnen is of de query mislukte (dan hoort de UI niets te beweren).
 */
const useHasResponses = (field, value) => {
    const [hasResponses, setHasResponses] = useState(/** @type {boolean|null} */ (null))

    useEffect(() => {
        if (!value) {
            setHasResponses(false)
            return
        }

        let cancelled = false
        setHasResponses(null)

        probeHasResponses(field, value)
            .then((hasAny) => {
                if (!cancelled) setHasResponses(hasAny)
            })
            .catch((error) => {
                // Zonder deze regel is een mislukte query niet te onderscheiden
                // van 'geen antwoorden'.
                console.error(
                    describeQueryError('QuestionnairesResponses', [[field, '==', value]], error),
                    error
                )
                if (!cancelled) setHasResponses(null)
            })

        return () => { cancelled = true }
    }, [field, value])

    return hasResponses
}

export default useHasResponses
